import { render, staticRenderFns } from "./Microsoft.vue?vue&type=template&id=d4902ad8&scoped=true&"
import script from "./Microsoft.vue?vue&type=script&lang=js&"
export * from "./Microsoft.vue?vue&type=script&lang=js&"
import style0 from "./Microsoft.vue?vue&type=style&index=0&id=d4902ad8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4902ad8",
  null
  
)

export default component.exports